import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol viewBox=\"0 0 19 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-left\">\r\n<path d=\"M14.75 9H4.25\" stroke=\"#34388E\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n<path d=\"M9.5 3.75L4.25 9L9.5 14.25\" stroke=\"#34388E\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol